import Vue from "vue";
import VueLodash from "vue-lodash";

Vue.use(VueLodash, {
  name: "_"
});
